<template>
  <q-input
    ref="q-input"
    v-incredi-input-num-type
    type="number"
    :class="{ disabled: $attrs.disable, 'not-valid': !isPassedValidation }"
    no-error-icon
    v-bind="$attrs"
    class="error incredi-input-container incredi-input gordita-400-12"
    outlined
    bottom-slots
    @blur="handleInputValidation"
  >
    <template #error="{ errorMessage }">
      <div class="gordita-400-12 ib-color-red">
        <span class="icon-Approval-error"><span class="path1"></span><span class="path2"></span></span>
        <span
          style="margin: 0 4px"
          class="message-text"
          >{{ errorMessage }}</span
        >
      </div>
    </template>
    <template #loading> </template>
    <template #append>
      <div
        style="padding-left: 5px"
        class="incredi-input-type gordita-400-12"
      >
        {{ inputType }}
      </div>
    </template>
  </q-input>
</template>

<script>
export default {
  name: 'IncrediInputWithDefinedType',
  props: {
    inputType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isPassedValidation: true,
    };
  },
  methods: {
    handleInputValidation() {
      this.isPassedValidation = this.$refs['q-input'].validate();
    },
  },
};
</script>

<style scoped lang="scss">
.incredi-input-container {
  :deep(.q-field__control-container) {
    height: 100%;
  }
  &.disabled {
    cursor: initial !important;
    background-color: $-system-app-background;
    border-color: $-system-app-border;

    .incredi-input-type {
      color: $-system-app-grey-76 !important;
    }
  }

  :deep(.q-field__control) {
    &:before {
      border: 1px solid $-system-app-border;
      box-sizing: border-box;
      border-radius: 2px;
    }
    &:hover:before {
      border: 1px solid $-system-app-grey-22;
    }
  }
  :deep(.q-field__bottom) {
    white-space: nowrap;
    padding-left: 0;
  }

  &.incredi-input-container:focus-within {
    :deep(.q-field__control) {
      border: 2px solid $-system-app-primary;
      border-radius: 2px;
      &:before {
        border: unset;
      }
      &:hover:before {
        border: unset;
      }
    }
  }
}
.not-valid {
  :deep(.q-field__control) {
    border: 1px solid $-system-app-error;
    border-radius: 2px;
    &:before {
      border: unset;
    }
    &:hover:before {
      border: unset;
    }
  }
}
</style>
